export default
{
    "tariffs": [
        {
            "name": "Free trial",
            "price": "00",
            "features": [
                "30 free trial",
                "5 Free Projects",
                "PHP 5 Enabled",
                "24/7 Supports"
            ]
        },
        {
            "name": "Basic",
            "price": "50",
            "features": [
                "30 free trial",
                "5 Free Projects",
                "PHP 5 Enabled",
                "24/7 Supports"
            ]
        },
        {
            "name": "Ultimates",
            "price": "99",
            "features": [
                "30 free trial",
                "5 Free Projects",
                "PHP 5 Enabled",
                "24/7 Supports"
            ]
        }
    ]
}